/**
 * Historical price chart range selector (stock analysis view).
 * Cutoffs use calendar dates at local midnight, consistent with existing 12M/3Y/5Y logic.
 */
export type HistoricalPriceChartTimeframe = '7D' | '30D' | '12M' | '3Y' | '5Y';

/** Demo: hide timeframe controls and lock the stock analysis chart to 1Y (12M). */
export const HISTORICAL_CHART_DEMO_LOCK_1Y = false;

export function historicalPriceCutoffForTimeframe(
  timeframe: HistoricalPriceChartTimeframe,
  now: Date = new Date(),
): Date {
  switch (timeframe) {
    case '7D': {
      const c = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      c.setDate(c.getDate() - 7);
      return c;
    }
    case '30D': {
      const c = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      c.setDate(c.getDate() - 30);
      return c;
    }
    case '12M':
      return new Date(now.getFullYear(), now.getMonth() - 12, now.getDate());
    case '3Y':
      return new Date(now.getFullYear() - 3, now.getMonth(), now.getDate());
    case '5Y':
      return new Date(now.getFullYear() - 5, now.getMonth(), now.getDate());
  }
}

/** Base calendar span for `/historical-prices?days=` (extra lookback is added separately in callers). */
export function historicalPriceFetchDaysForTimeframe(
  timeframe: HistoricalPriceChartTimeframe,
): number {
  switch (timeframe) {
    case '7D':
      return 14;
    case '30D':
      return 45;
    case '12M':
      return 365;
    case '3Y':
      return 1095;
    case '5Y':
      return 1825;
  }
}
